module.exports = __webpack_public_path__ + "static/media/16UNODC25.ec0b89fd.jpg";